import { webComponentProperties } from '../api/web-component-properties'
import { configuratorInterface } from '../systems/configurator-interface'

export const webComponentOptionsHandler = configuratorInterface.createGetWebComponentOptionsHandler(() => ({
  properties: webComponentProperties,
}))
